import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=b2edf7a6&scoped=true&"
import script from "./addDialog.vue?vue&type=script&lang=js&"
export * from "./addDialog.vue?vue&type=script&lang=js&"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=b2edf7a6&lang=less&scoped=true&"
import style1 from "./addDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2edf7a6",
  null
  
)

export default component.exports